<template>
  <div>
    <h1 class="text-center">Nyheder</h1>

    <v-timeline align-top dense>
      <v-timeline-item
        v-for="(item, index) in news"
        :key="index"
        :color="item.color"
        fill-dot
        :small="index !== 0"
        class="align-center"
      >
        <v-row class="pt-1">
          <v-col cols="3">
            <small>{{ item.date }}</small>
            <small>{{ index }}</small>
          </v-col>
          <v-col>
            <strong>{{ item.title }}</strong>
            <div class="caption">{{ item.text }}</div>
          </v-col>
        </v-row>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Nyheder',
  data: () => ({
    // Todo:
    // - Flyt disse over i store senere
    // - Man skal kunne vælge farve når man opretter en nyhed (Gør så der er 6 valgmuligheder eller sådan noget)
    // - Man skal evt kunne vælge størrelse på dens dot ud fra "vigtighed" (small/large prop)
    // - Fix at man kan lave linjeskift i teksten. (f.eks. i nyhed nr. 2)

    news: [
      {
        date: '25 April 2015',
        title: 'Hvalpe',
        text:
          'Tirsdag 21 April 2015 fik Hillsbrook Kira 8 hvalpe. 7 hanner og 1 tæve - alle gule.',
        color: 'cyan lighten-1'
      },
      {
        date: '21 Februar 2015',
        title: 'Parret',
        text: `
          Hillsbrook Kira er blevet i parret med DK FTCH DK TM MPM 2013 Jobeshill Olof (Brimson).
          Der forventes hvalpe omkring start maj.
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '04 Marts 2012',
        title: '2 hvalpe tilbage',
        text: `
          Der er to hvalpe tilbage. 1 sort han og 1 sort tæve.
          Ønskes der billeder af dem - kontakt os..
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '31 December 2011',
        title: 'Nye hvalpe',
        text: `
          Woodmagic Willow fik 7 finde hvalpe.
          4 sorte tæver, 1 gul tæve, 1 sort han og 1 gul han.
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '01 November 2011',
        title: 'Parret',
        text: `
          Woodmagic Willow er blevet parret med Foxon Joodii. Der forventes hvalpe engang efter jul.
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '01 November 2011',
        title: 'Nye hvalpe',
        text: `
          Foxon Joodii havde damebesøg af Nordjyden Road Runner, og der kom fine hvalpe efter de to.
          Nordjydens Road Runner ejes af Rene Larsen, og hvis du er interesseret i hvalp efter denne kombination kan du kontakte Rene her:

          Tlf.: 51 74 01 98 eller email: 
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '29 Maj 2011',
        title: 'Markprøve',
        text: `
          Woodmagic Willow fik i dag 1. pr. Markprøve B begynderklasse.
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '8 Maj 2011',
        title: 'Parret',
        text: `
          Foxon Joodii har haft besøg af tæven Luna,
          som ejes af Mette Buhr og Rune Rübner-Petersen, Kennel Broadleaves.

          Er du interesseret i hvalp efter kombinationen, kan Mette og Rune kontaktes på

          Tlf: 54 85 09 78 / Mobil (Rune) 40 31 42 21 / Mobil (Mette) 20 16 59 58
          eller email: fuglsang.rrp@mail.dk
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '2 April 2011',
        title: 'Parret',
        text: `
          Foxon Joodii har i en uges tid haft besøg af tæven Michnos Drina Daim,
          som ejes af Charlotte og Lars Nørgaard, Kennel Michno, nordjylland.

          Er du interesseret i hvalp efter kombinationen, kan Charlotte og Lars kontaktes på

          Tlf: 98 38 41 98 / 40 10 17 32 eller email: mail@michno.dk
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '14 Marts 2011',
        title: 'Parret',
        text: `
          Foxon Joodii har haft besøg af tæven Dawn, som ejes af Elisabeth Johansen,
          Kennel Lost Lake Labradors, Græsted.

          Er du interesseret i hvalp efter kombinationen kan Elisabeth kontaktes på
          Tlf: 40 16 78 35 eller email e.johansen@dias.kvl.dk
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '7 Marts 2011',
        title: 'Parret',
        text: `
          Foxon Joodii har i en periode haft feminint besøg af tæven Lochiness Black Pearl som ejes af
          Bent Skovdal, Slagelse.

          Er du interesseret i hvalp efter kombinationen kan Bent kontaktes på
          Tlf: 58 53 19 95 eller email: b.skovdal@mail.tele.dk
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '6 Marts 2011',
        title: 'Bestået brugsprøve',
        text: `
          I dag har Eddie (Swaine Guduri) været til brugsprøve - og den er bestået!
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '14 Februar 2011',
        title: 'Parret',
        text: `
          Så har Foxon Joodii haft besøg af tæven Kado Black Magic,
          som ejes af Hanne Koldkær kennel Rykind, nordjylland.

          Skulle du være interesseret i hvalp fra kombinationen kan Hanne kontaktes på
          
          Tlf: 25 54 50 95 eller email: rykind@c.dk
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '5 Januar 2011',
        title: 'Parret',
        text: `
          Skulle du være interesseret i hvalp fra kombinationen kan Hanne kontaktes på

          Tlf: 25 54 50 95 eller email: rykind@c.dk
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '5 Januar 2011',
        title: 'Ledige hanner',
        text: `
          Vi har 2 ledige hanner tilbage

          Hillsbrook J. Paddy & Hillsbrook J. Bastian
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '28 December 2010',
        title: 'Sundhedsattest',
        text: `
          I dag har hvalpene efter Woodmagic Willow og Michnos Go Winning Colours
          været en tur hos dyrlægen og blevet sundhedsundersøgt og fået udarbejdet sundhedsattest.
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '5 November 2010',
        title: 'Nye hvalpe',
        text: `
          Woodmagic Willow fødte i dag 7 små fine hvalpe. Det blev til 4 drenge og 3 piger, på knap 4 timer.
          De har det alle godt...

          Vi vil så vidt muligt smide billeder ind løbende af hvalpene. De kan findes ved at klikke her...
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '13 Oktober 2010',
        title: 'Stamtavle sammensat',
        text: `
          Nu er stamtavlen for J-kuldet sammensat og kan ses under hvalpe eller ved at klikke her.
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '25 September 2010',
        title: 'Parret',
        text: `
          Woodmagic Willow er parret med Michnos Go Winning Colours.
          Hvalpe forventes ca. 7 November 2010.
          `,
        color: 'cyan lighten-1'
      },
      {
        date: '29 Juli 2010',
        title: 'Ny labrador',
        text: `
          Så er der kommer ny labrador i kennelen. Det er Swaine Guduri (Eddie). Han er hentet i Barnsley, England.
          `,
        color: 'cyan lighten-1'
      }
    ]
  }),
  computed: {
    ...mapState(['test', 'dogs'])
  }
};
</script>
